import { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import resumePDF from "../assets/Akshay-resume.pdf";

// Set PDF worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [numPages, setNumPages] = useState(null);
  // const resumePDF ="https://opw6a4o9oijpcqbg.public.blob.vercel-storage.com/resume/Akshay-resume.pdf";

  const toRotate = [
    "AI Engineer",
    "Frontend Developer",
    "Backend Developer",
    "Full Stack Developer",
  ];
  const period = 1000;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleDownloadPDF = () => {
    const link = document.createElement("a");
    link.href = resumePDF;
    link.download = "Akshay-Resume.pdf";
    link.click();
    if (window.gtag) {
      window.gtag('event', 'resume_download', {
        event_category: 'engagement',
        event_label: 'Download Resume Button',
      });
    }
  
    // Send custom event to Clarity (optional)
    if (window.clarity) {
      window.clarity('track', 'Resume Downloaded');
    }
  };

  const tick = useCallback(() => {
    const i = loopNum % toRotate.length;
    const fullText = toRotate[i];
    const updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) setDelta((prev) => prev / 2);

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prev) => prev - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum((prev) => prev + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prev) => prev + 1);
    }
  }, [isDeleting, text, loopNum]);

  useEffect(() => {
    const ticker = setInterval(() => {
      tick();
    }, delta);
    return () => clearInterval(ticker);
  }, [tick, delta]);

  return (
    <>
      <section className="banner" id="home">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} xl={7}>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div
                    className={
                      isVisible ? "animate__animated animate__fadeIn" : ""
                    }
                  >
                    <span className="tagline">Welcome to my Portfolio</span>
                    <h1 className="intro-heading">
                      Hi! There{" "}
                      <span
                        className="wave"
                        role="img"
                        aria-label="waving hand"
                      >
                        👋🏻
                      </span>
                      <br />
                      I'm <span className="name-span">Akshay.M</span>
                      <br />
                      <span className="txt-rotate">
                        <span className="wrap">{text}</span>
                      </span>
                    </h1>
                    <p>
                      I’m a passionate{" "}
                      <strong style={{ color: "white" }}>
                        Full Stack Developer
                      </strong>{" "}
                      with a strong focus on building user-friendly, accessible,
                      and responsive web applications. Beyond frontend and
                      backend development, I also work with{" "}
                      <strong style={{ color: "white" }}>
                        open-source large language models (LLMs)
                      </strong>
                      , integrating AI capabilities into real-world projects.
                      I'm a lifelong learner, and each new challenge is an
                      opportunity to explore, innovate, and grow.
                    </p>
                    <button
                      onClick={() => {
                        // Show your resume modal
                        setShowModal(true);

                        // 🔹 GA4 Event Tracking
                        if (window.gtag) {
                          window.gtag("event", "view_resume_modal", {
                            event_category: "engagement",
                            event_label: "View Resume Button",
                          });
                        }

                        // 🔹 Clarity Custom Event Tracking
                        if (window.clarity) {
                          window.clarity("track", "View Resume Modal");
                        }
                      }}
                    >
                      View Resume <ArrowRightCircle size={25} />
                    </button>
                  </div>
                )}
              </TrackVisibility>
            </Col>
            <Col xs={12} md={6} xl={5}>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div
                    className={
                      isVisible ? "animate__animated animate__zoomIn" : ""
                    }
                  >
                    <img src={headerImg} alt="Header illustration" />
                  </div>
                )}
              </TrackVisibility>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        dialogClassName="pdf-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>My Resume</Modal.Title>
          <button
            className="btn btn-outline-primary ms-auto"
            onClick={handleDownloadPDF}
          >
            Download PDF
          </button>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          <Document file={resumePDF} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <div key={`page_${index + 1}`} className="pdf-page-wrapper">
                <Page
                  pageNumber={index + 1}
                  scale={1.2}
                  renderTextLayer={true}
                  renderAnnotationLayer={true}
                />
              </div>
            ))}
          </Document>
        </Modal.Body>
      </Modal>
    </>
  );
};
